export default __webpack_public_path__ + "static/media/BC_246_BC_R9326_tn.d1129f55.jpg";